module.exports = __webpack_public_path__ + "img/google-maps-marker.2ac0f20e.png";